export interface ReleaseInfo {
  version: string;
  releasedAt: string;
  formattedReleasedAt: string;
}

function formatReleaseTime(releasedAt: string): string {
  const releaseDate = new Date(releasedAt);

  if (Number.isNaN(releaseDate.getTime())) {
    return 'unknown';
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(releaseDate);
}

export const releaseInfo: ReleaseInfo = {
  version: __APP_VERSION__,
  releasedAt: __APP_RELEASED_AT__,
  formattedReleasedAt: formatReleaseTime(__APP_RELEASED_AT__),
};
